<div class="row">
  <div class="col-md h-100">
    <!-- <nz-upload nzType="drag" [nzMultiple]="true" [nzShowUploadList]="showUploadList" [nzBeforeUpload]="beforeUpload"
      [nzLimit]="limite" [nzDisabled]="disableUpload" class="upload-file" [nzFileListRender]="fileListTpl"
      [nzAccept]="tiposArquivos" [nzFileType]="acceptedFileTypes"> -->

    <nz-upload nzType="drag" [nzLimit]="limite" [nzDisabled]="disableUpload" [nzFileListRender]="fileListTpl"
      [nzCustomRequest]="customRequest" [nzBeforeUpload]="beforeUpload" [nzAccept]="tiposArquivos"
      [nzMultiple]="true" [nzShowUploadList]="true" class="upload-file">
      <p class="ant-upload-drag-icon upload-icon-content">
        <i nz-icon>
          <i class="fi fi-rs-cloud-upload-alt"></i>
        </i>
      </p>

      <div class="d-flex align-items-center justify-content-center" *ngIf="carregandoArquivos">
        <div eds-spinner></div>
        <p class="ml-2">Carregando arquivos no navegador...</p>
      </div>
      <ng-container *ngIf="!carregandoArquivos">
        <p class="ant-upload-text upload-titulo">Arraste aqui o arquivo</p>
        <p class="ant-upload-hint upload-descricao">
          <a class="link-anchor">ou clique aqui se preferir procurar no computador</a>
        </p>
        <p class="ant-upload-hint upload-descricao">Tamanho máximo: {{ tamanhoMaximoMb }} MB</p>
      </ng-container>

      <ng-template #fileListTpl>

      </ng-template>
    </nz-upload>
  </div>
</div>
